/* Candlico Halloween — interactive effects + custom section behaviour.
   Page-wide effects are controlled in Theme settings > Halloween (window.HW_CONFIG).
   Section behaviour (hero jack, trick-or-treat, countdown, bundle) always runs. */
(function () {
  'use strict';
  var CFG = window.HW_CONFIG || {};
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = window.matchMedia('(pointer: fine)').matches;
  var FX = !!CFG.enabled && (CFG.scope === 'all' || CFG.isHome);
  var S = CFG.strings || {};
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function rnd(a, b) { return a + Math.random() * (b - a); }
  function pick(a) { return a[Math.floor(Math.random() * a.length)]; }
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }

  /* ---------- sprites ---------- */
  var SVG = {
    pumpkin: '<svg viewBox="0 0 40 36"><path d="M20 6c-1-3 0-5 3-6l1 2c-2 1-2 2-2 4z" fill="#6bbf2a"/><ellipse cx="13" cy="21" rx="10" ry="13" fill="#d9540a"/><ellipse cx="27" cy="21" rx="10" ry="13" fill="#d9540a"/><ellipse cx="20" cy="21" rx="11" ry="14" fill="#ff7518"/><path d="M12 17l5-1-2 5zM28 17l-5-1 2 5zM12 25c4 4 12 4 16 0-2 1-3 2-4 0-1 2-3 2-4 0-1 2-3 2-4 0-1 1-2 1-4 0z" fill="#ffe08a"/></svg>',
    bat: '<svg viewBox="0 0 64 28"><path fill="#c9a6ff" d="M32 10c-2-4-1-7 0-9 1 2 2 3 3 3 1 0 2-1 3-3 1 2 2 5 0 9 6-6 14-8 26-6-5 2-8 6-9 11-4-3-8-2-10 2-3-3-7-3-9 1-1-2-2-3-4-3s-3 1-4 3c-2-4-6-4-9-1-2-4-6-5-10-2C8 10 5 6 0 4c12-2 20 0 26 6"/></svg>',
    candy: function (c) { return '<svg viewBox="0 0 40 20"><path d="M10 10 0 2v16zM30 10l10-8v16z" fill="' + c + '"/><ellipse cx="20" cy="10" rx="11" ry="8" fill="' + c + '"/><path d="M15 4c3 4 3 8 0 12M21 2.5c3 5 3 10 0 15M27 4c2.5 4 2.5 8 0 12" stroke="#fff" stroke-opacity=".55" stroke-width="2" fill="none"/></svg>'; },
    corn: '<svg viewBox="0 0 24 28"><path d="M12 1 7.5 10h9z" fill="#fff6e0"/><path d="M7.5 10h9l3.5 9H4z" fill="#ff8a1a"/><path d="M4 19h16l2 5c0 3-20 3-20 0z" fill="#ffd23a"/></svg>',
    star: function (c) { return '<svg viewBox="0 0 24 24"><path d="M12 1l3.2 7 7.6.8-5.7 5.1 1.7 7.5L12 17.6 5.2 21.4l1.7-7.5L1.2 8.8 8.8 8z" fill="' + c + '"/></svg>'; },
    lolly: function (c) { return '<svg viewBox="0 0 24 36"><path d="M12 22v13" stroke="#f4e6cf" stroke-width="2.5" stroke-linecap="round"/><circle cx="12" cy="11" r="10" fill="' + c + '"/><path d="M12 11m-6 0a6 6 0 1 0 6-6 4 4 0 1 1-4 4" stroke="#fff" stroke-opacity=".6" stroke-width="2" fill="none"/></svg>'; },
    ghost: '<svg viewBox="0 0 30 36"><path d="M15 0C7 0 2 6 2 14v22l4-4 4 4 5-4 5 4 4-4 4 4V14C28 6 23 0 15 0z" fill="#fff6ea"/><circle cx="10" cy="14" r="2.5" fill="#1b120c"/><circle cx="20" cy="14" r="2.5" fill="#1b120c"/><ellipse cx="15" cy="22" rx="3" ry="4" fill="#1b120c"/></svg>'
  };
  var COLORS = ['#ff4fa3', '#9be22d', '#8a5bd6', '#ff7518', '#3fc6ff', '#ffd23a'];
  function sweet() {
    var t = pick(['candy', 'corn', 'star', 'lolly', 'pumpkin']);
    return typeof SVG[t] === 'function' ? SVG[t](pick(COLORS)) : SVG[t];
  }

  /* ---------- sound (synth, off until the visitor turns it on) ---------- */
  var AC = null, soundOn = CFG.sounds && store('hw-sound') === '1';
  function tone(f1, f2, dur, type, vol) {
    if (!soundOn) return;
    try {
      AC = AC || new (window.AudioContext || window.webkitAudioContext)();
      var o = AC.createOscillator(), g = AC.createGain(), t = AC.currentTime;
      o.type = type || 'triangle'; o.frequency.setValueAtTime(f1, t); o.frequency.exponentialRampToValueAtTime(f2, t + dur);
      g.gain.setValueAtTime(vol || .06, t); g.gain.exponentialRampToValueAtTime(.0001, t + dur);
      o.connect(g).connect(AC.destination); o.start(t); o.stop(t + dur);
    } catch (e) {}
  }
  var sfx = {
    pop: function () { tone(520, 1200, .12, 'sine', .07); },
    boo: function () { tone(320, 90, .7, 'sawtooth', .04); tone(240, 70, .8, 'triangle', .06); },
    chime: function () { [660, 880, 1320].forEach(function (f, i) { setTimeout(function () { tone(f, f * 1.01, .25, 'sine', .06); }, i * 90); }); },
    whoosh: function () { tone(900, 120, .35, 'sine', .05); }
  };

  /* ---------- toast ---------- */
  var tt;
  function toast(m) {
    var t = $('.hw-toast'); if (!t) return;
    t.textContent = m; t.classList.add('is-show'); clearTimeout(tt);
    tt = setTimeout(function () { t.classList.remove('is-show'); }, 2400);
  }

  /* ---------- sprites, bursts, swarms ---------- */
  function sprite(html, x, y, size) {
    var d = document.createElement('div'); d.className = 'hw-fx'; d.setAttribute('aria-hidden', 'true');
    d.style.width = d.style.height = size + 'px'; d.innerHTML = html;
    d.style.transform = 'translate(' + (x - size / 2) + 'px,' + (y - size / 2) + 'px)';
    document.body.appendChild(d); return d;
  }
  function burst(x, y, n, kinds) {
    if (!CFG.enabled) return;
    n = RM ? Math.min(n || 9, 3) : (n || 9);
    for (var i = 0; i < n; i++) {
      var k = kinds ? pick(kinds) : pick(['pumpkin', 'bat', 'sweet', 'sweet', 'pumpkin']);
      var s = rnd(22, 40), el = sprite(k === 'sweet' ? sweet() : SVG[k], x, y, s);
      var a = rnd(0, Math.PI * 2), dist = rnd(60, 150), dx = Math.cos(a) * dist, dy = Math.sin(a) * dist - 60;
      var x0 = x - s / 2, y0 = y - s / 2;
      el.animate([
        { transform: 'translate(' + x0 + 'px,' + y0 + 'px) scale(.3)', opacity: 1 },
        { transform: 'translate(' + (x0 + dx * .7) + 'px,' + (y0 + dy) + 'px) scale(1.1) rotate(' + rnd(-180, 180) + 'deg)', opacity: 1, offset: .55 },
        { transform: 'translate(' + (x0 + dx) + 'px,' + (y0 + dy + 120) + 'px) scale(.8) rotate(' + rnd(-360, 360) + 'deg)', opacity: 0 }
      ], { duration: rnd(900, 1400), easing: 'cubic-bezier(.2,.7,.4,1)' }).onfinish = (function (e) { return function () { e.remove(); }; })(el);
    }
  }
  function swarm(n) {
    if (!CFG.enabled) return;
    n = RM ? 3 : (n || 16);
    for (var i = 0; i < n; i++) {
      var s = rnd(26, 54), y = rnd(60, window.innerHeight * .7), el = sprite(SVG.bat, -80, y, s), amp = rnd(20, 70), W = window.innerWidth;
      el.animate([0, .25, .5, .75, 1].map(function (o, j) {
        return { transform: 'translate(' + (-80 + o * (W + 160)) + 'px,' + (y + Math.sin(j * 1.6) * amp) + 'px) scaleY(' + (j % 2 ? .55 : 1) + ')', offset: o };
      }), { duration: rnd(2200, 3800), delay: i * 90, easing: 'linear', fill: 'backwards' }).onfinish = (function (e) { return function () { e.remove(); }; })(el);
    }
  }

  /* ---------- money ---------- */
  function money(cents) {
    var f = String(CFG.moneyFormat || 'Rs. {{amount}}').replace(/<[^>]*>/g, ''), n = cents / 100;
    function fmt(v, dec, th, dp) { var p = v.toFixed(dec).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return p[0] + (p[1] ? dp + p[1] : ''); }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return fmt(n, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(n, 2, "'", '.');
        default: return fmt(n, 2, ',', '.');
      }
    });
  }

  /* ---------- cart ---------- */
  function cartIcon() { return document.getElementById('cart-icon-bubble'); }
  function fly(src) {
    var cart = cartIcon(); if (!src || !cart || !CFG.enabled) return;
    var a = src.getBoundingClientRect(), b = cart.getBoundingClientRect(), s = 30;
    var x0 = a.left + a.width / 2, y0 = a.top + a.height / 2, x1 = b.left + b.width / 2, y1 = b.top + b.height / 2;
    var el = sprite(sweet(), x0, y0, s); sfx.whoosh();
    el.animate([
      { transform: 'translate(' + (x0 - s / 2) + 'px,' + (y0 - s / 2) + 'px) scale(1)' },
      { transform: 'translate(' + ((x0 + x1) / 2 - s / 2) + 'px,' + (Math.min(y0, y1) - 160 - s / 2) + 'px) scale(1.5) rotate(200deg)', offset: .45 },
      { transform: 'translate(' + (x1 - s / 2) + 'px,' + (y1 - s / 2) + 'px) scale(.4) rotate(420deg)', opacity: .6 }
    ], { duration: RM ? 10 : 850, easing: 'cubic-bezier(.45,0,.55,1)' }).onfinish = function () {
      el.remove(); var c = cartIcon(); if (!c) return;
      c.classList.remove('hw-jiggle'); void c.offsetWidth; c.classList.add('hw-jiggle'); sfx.pop();
    };
  }
  function addToCart(items, src) {
    var drawer = document.querySelector('cart-drawer');
    if (CFG.cartFx) fly(src);
    var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) { toast(res.description || res.message || S.error); return false; }
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.classList.remove('is-empty');
        drawer.renderContents(res);
      } else {
        if (res.sections && res.sections['cart-icon-bubble'] && cartIcon()) {
          var d = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html'), s = d.querySelector('.shopify-section');
          if (s) cartIcon().innerHTML = s.innerHTML;
        }
        toast(S.added);
      }
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'halloween', cartData: res });
      return true;
    }).catch(function () { toast(S.error); return false; });
  }
  window.HW = { addToCart: addToCart, burst: burst, swarm: swarm, toast: toast, money: money, sfx: sfx };

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-hw-add]'); if (!b) return;
    e.preventDefault();
    var id = parseInt(b.getAttribute('data-variant-id'), 10); if (!id || b.disabled) return;
    b.disabled = true;
    addToCart([{ id: id, quantity: 1 }], b).then(function (ok) {
      b.disabled = false;
      if (ok && b.classList.contains('hw-add')) { b.classList.add('is-done'); b.textContent = '✓'; setTimeout(function () { b.classList.remove('is-done'); b.textContent = '+'; }, 1600); }
    });
  });
  /* candy flies to the cart from every normal add-to-cart form too */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!CFG.enabled || !CFG.cartFx || !f.action || f.action.indexOf('/cart/add') === -1) return;
    fly(e.submitter || f.querySelector('[type="submit"]') || f);
  }, true);

  /* ---------- header toggles (candy rain, sound) ---------- */
  function headerButton(id, label, svg, pressed) {
    var icons = $('.header__icons'), cart = cartIcon(); if (!icons || document.getElementById(id)) return null;
    var b = document.createElement('button'); b.type = 'button'; b.id = id;
    b.className = 'header__icon link focus-inset hw-hdr-btn hw-hdr-btn--opt';
    b.setAttribute('aria-label', label); b.title = label; b.setAttribute('aria-pressed', pressed ? 'true' : 'false'); b.innerHTML = svg;
    if (cart && cart.parentNode === icons) icons.insertBefore(b, cart); else icons.appendChild(b);
    return b;
  }

  /* ---------- 1. candy rain + catching ---------- */
  var rainOn = false, drops = [], cv, ctx, W, H, raf, imgs = [], caught = 0;
  function initRain() {
    if (!FX || !CFG.rain) return;
    cv = document.createElement('canvas'); cv.id = 'hwCandyRain'; cv.setAttribute('aria-hidden', 'true'); document.body.appendChild(cv);
    ctx = cv.getContext('2d');
    [SVG.candy('#ff4fa3'), SVG.candy('#9be22d'), SVG.candy('#8a5bd6'), SVG.corn, SVG.corn, SVG.star('#ffd23a'), SVG.lolly('#ff7518'), SVG.lolly('#3fc6ff'), SVG.pumpkin].forEach(function (s) {
      var im = new Image(); im.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(s.replace('<svg ', '<svg xmlns="http://www.w3.org/2000/svg" ')); imgs.push(im);
    });
    var btn = headerButton('hwRainToggle', S.rain, '<svg viewBox="0 0 24 24"><path d="M7 12l-4-3v6zM17 12l4-3v6z"/><ellipse cx="12" cy="12" rx="5.5" ry="4.5"/></svg>', true);
    if (btn) btn.addEventListener('click', function () { setRain(!rainOn); store('hw-rain', rainOn ? '1' : '0'); toast(rainOn ? S.rainOn : S.rainOff); });
    window.addEventListener('resize', function () { if (rainOn) size(); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) cancelAnimationFrame(raf); else if (rainOn) frame(); });
    setRain(!RM && store('hw-rain') !== '0');
  }
  function size() {
    var dpr = Math.min(2, window.devicePixelRatio || 1); W = window.innerWidth; H = window.innerHeight;
    cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    var want = Math.round(Math.min(CFG.density || 24, W / 40));
    while (drops.length < want) drops.push(newDrop(true)); drops.length = want;
  }
  function newDrop(anyY) { return { x: rnd(0, W), y: anyY ? rnd(-H, H) : rnd(-120, -30), s: rnd(16, 30), v: rnd(.5, 1.4), r: rnd(0, 6.28), vr: rnd(-.03, .03), sw: rnd(0, 6.28), im: pick(imgs), a: rnd(.55, .9), cx: 0 }; }
  function frame() {
    ctx.clearRect(0, 0, W, H);
    for (var i = 0; i < drops.length; i++) {
      var d = drops[i]; d.y += d.v; d.sw += .02; d.r += d.vr; d.cx = d.x + Math.sin(d.sw) * 18;
      if (d.y > H + 40) { var n = newDrop(false); for (var k in n) d[k] = n[k]; }
      if (!d.im.complete || !d.im.naturalWidth) continue;
      var w = d.s, h = d.s * (d.im.naturalHeight / d.im.naturalWidth);
      ctx.save(); ctx.globalAlpha = d.a; ctx.translate(d.cx, d.y); ctx.rotate(d.r); ctx.drawImage(d.im, -w / 2, -h / 2, w, h); ctx.restore();
    }
    raf = requestAnimationFrame(frame);
  }
  function setRain(on) {
    rainOn = on; var b = document.getElementById('hwRainToggle'); if (b) b.setAttribute('aria-pressed', on ? 'true' : 'false');
    cancelAnimationFrame(raf);
    if (on) { cv.hidden = false; size(); frame(); } else { ctx.clearRect(0, 0, W || 0, H || 0); cv.hidden = true; }
  }
  function bumpHud(sel) { var e = $(sel); if (!e) return; e.classList.remove('is-bump'); void e.offsetWidth; e.classList.add('is-bump'); }
  function showHud() { var h = $('.hw-hud'); if (h && FX && (CFG.rain || CFG.ghosts)) h.hidden = false; }

  /* ---------- 2. click magic (and catching candy) ---------- */
  document.addEventListener('click', function (e) {
    if (!FX) return;
    if (e.target.closest('input,textarea,select,dialog,cart-drawer,.menu-drawer,details[open] > .header__submenu')) return;
    var x = e.clientX, y = e.clientY; if (!x && !y) return;
    if (rainOn) {
      for (var i = 0; i < drops.length; i++) {
        var d = drops[i];
        if (Math.hypot(d.cx - x, d.y - y) < d.s * .9) {
          caught++; var c = $('#hwCandyN'); if (c) c.textContent = caught; bumpHud('#hwHudCandy'); showHud();
          sfx.chime(); burst(x, y, 8, ['sweet']); var n = newDrop(false); for (var k in n) d[k] = n[k];
          if (caught === 10) toast(S.sweetTooth);
          return;
        }
      }
    }
    if (!CFG.burst || e.target.closest('a,button,label,summary,[role="button"]')) return;
    sfx.pop(); burst(x, y);
  });

  /* ---------- 3. haunted cursor ---------- */
  function initTrail() {
    if (!FX || !CFG.trail || !FINE || RM) return;
    var last = 0;
    window.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      var n = performance.now(); if (n - last < 28) return; last = n;
      var t = document.createElement('div'), c = pick(['#ff7518', '#9be22d', '#ffd23a', '#c9a6ff']), sz = rnd(4, 9);
      t.className = 'hw-trail'; t.style.background = c; t.style.boxShadow = '0 0 10px ' + c; t.style.width = t.style.height = sz + 'px';
      document.body.appendChild(t);
      t.animate([
        { transform: 'translate(' + (e.clientX - sz / 2) + 'px,' + (e.clientY - sz / 2) + 'px) scale(1)', opacity: .95 },
        { transform: 'translate(' + (e.clientX - sz / 2 + rnd(-14, 14)) + 'px,' + (e.clientY - sz / 2 + rnd(10, 34)) + 'px) scale(.2)', opacity: 0 }
      ], { duration: 650, easing: 'ease-out' }).onfinish = function () { t.remove(); };
    }, { passive: true });
  }

  /* ---------- 8. scroll spider ---------- */
  function initSpider() {
    var sp = $('.hw-spider'); if (!sp) return;
    if (!FX || !CFG.spider) { sp.remove(); return; }
    sp.hidden = false; var scared = false;
    function spin() { if (scared) return; var max = document.documentElement.scrollHeight - window.innerHeight; var p = max > 0 ? window.scrollY / max : 0; sp.style.height = (50 + p * window.innerHeight * .5) + 'px'; }
    window.addEventListener('scroll', spin, { passive: true }); spin();
    sp.querySelector('button').addEventListener('click', function () {
      scared = true; sp.classList.add('is-up'); sfx.whoosh(); toast(S.spider);
      setTimeout(function () { sp.classList.remove('is-up'); scared = false; spin(); }, 2600);
    });
  }

  /* ---------- 5. boo cards on regular theme product cards ---------- */
  function booCards(root) {
    if (!CFG.enabled || !CFG.boo) return;
    $$('.card-wrapper:not(.hw-boo)', root).forEach(function (w) {
      w.classList.add('hw-boo');
      var p = document.createElement('span'); p.className = 'hw-peek'; p.setAttribute('aria-hidden', 'true'); p.innerHTML = SVG.ghost + '<b>boo!</b>';
      w.insertBefore(p, w.firstChild);
      tilt(w, w.querySelector('.card'));
    });
    $$('.hw-card:not(.hw-tilted)', root).forEach(function (c) { c.classList.add('hw-tilted'); tilt(c, c.querySelector('.hw-card__in')); });
  }
  function tilt(host, inner) {
    if (!inner || !FINE || RM) return;
    host.addEventListener('pointermove', function (e) {
      var r = host.getBoundingClientRect(), px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
      inner.style.transform = 'rotateY(' + ((px - .5) * 12) + 'deg) rotateX(' + ((.5 - py) * 10) + 'deg)';
    });
    host.addEventListener('pointerleave', function () { inner.style.transform = ''; });
  }

  /* ---------- 10. ghost hunt ---------- */
  function initGhosts() {
    if (!FX || !CFG.ghosts || !CFG.isHome) return;
    var hosts = $$('main .shopify-section').filter(function (s) { return s.offsetHeight > 260; });
    for (var i = hosts.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)), t = hosts[i]; hosts[i] = hosts[j]; hosts[j] = t; }
    var count = Math.min(CFG.ghostCount || 5, hosts.length), found = 0;
    var tot = $('#hwGhostTotal'); if (tot) tot.textContent = count;
    if (!count) return;
    showHud();
    hosts.slice(0, count).forEach(function (h) {
      h.classList.add('hw-ghost-host');
      var g = document.createElement('button'); g.type = 'button'; g.className = 'hw-hid'; g.setAttribute('aria-label', S.ghostLabel); g.innerHTML = SVG.ghost;
      g.style.left = rnd(4, 90) + '%'; g.style.top = rnd(8, 80) + '%';
      h.appendChild(g);
      g.addEventListener('click', function () {
        if (g.classList.contains('is-found')) return;
        g.classList.add('is-found'); found++; var n = $('#hwGhostN'); if (n) n.textContent = found; bumpHud('#hwHudGhost'); sfx.boo();
        var r = g.getBoundingClientRect(); burst(r.left + r.width / 2, r.top + r.height / 2, 6, ['bat', 'sweet']);
        if (found < count) toast(S.ghostLeft.replace('[n]', count - found));
        else setTimeout(function () { swarm(20); var d = $('#hwGhostDlg'); if (d && d.showModal) d.showModal(); sfx.chime(); }, 700);
      });
    });
    var dlg = $('#hwGhostDlg');
    if (dlg) {
      dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.closest('[data-hw-close]')) dlg.close(); });
      var cp = $('[data-hw-copy]', dlg);
      if (cp) cp.addEventListener('click', function () {
        var code = $('.hw-dlg__code', dlg).textContent.trim();
        var done = function () { cp.textContent = S.copied; };
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, function () { selectCode(); });
        else selectCode();
        function selectCode() { var r = document.createRange(); r.selectNodeContents($('.hw-dlg__code', dlg)); var s = window.getSelection(); s.removeAllRanges(); s.addRange(r); }
      });
    }
  }

  /* ---------- sound toggle ---------- */
  function initSound() {
    if (!FX || !CFG.sounds) return;
    var b = headerButton('hwSoundToggle', S.sound, '<svg viewBox="0 0 24 24"><path d="M4 9h4l5-4v14l-5-4H4z"/><path d="M16 9c1.5 1.5 1.5 4.5 0 6M18.5 6.5c3 3 3 8 0 11"/></svg>', soundOn);
    if (b) b.addEventListener('click', function () { soundOn = !soundOn; store('hw-sound', soundOn ? '1' : '0'); b.setAttribute('aria-pressed', soundOn ? 'true' : 'false'); toast(soundOn ? S.soundOn : S.soundOff); if (soundOn) sfx.boo(); });
  }

  /* ---------- newsletter ghost ---------- */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!CFG.enabled || !CFG.nlGhost || RM || !f.classList || !f.classList.contains('newsletter-form') || f.getAttribute('data-hw-sent')) return;
    if (!f.checkValidity()) return;
    e.preventDefault();
    var btn = f.querySelector('button[type="submit"], button') || f, r = btn.getBoundingClientRect(), s = 60;
    var el = sprite(SVG.ghost.replace('</svg>', '<rect x="8" y="22" width="14" height="10" rx="1" fill="#ffd23a"/><path d="M8 22l7 5 7-5" stroke="#b5651d" fill="none"/></svg>'), r.left + r.width / 2, r.top, s);
    sfx.whoosh();
    el.animate([
      { transform: 'translate(' + (r.left + r.width / 2 - s / 2) + 'px,' + (r.top - s / 2) + 'px)' },
      { transform: 'translate(' + (r.left + r.width / 2 + 60 - s / 2) + 'px,' + (r.top - 200) + 'px) rotate(12deg)', offset: .5 },
      { transform: 'translate(' + (window.innerWidth + 80) + 'px,-120px) rotate(-10deg)', opacity: .4 }
    ], { duration: 1200, easing: 'ease-in' });
    setTimeout(function () { f.setAttribute('data-hw-sent', '1'); el.remove(); HTMLFormElement.prototype.submit.call(f); }, 1000);
  });

  /* =====================================================================
     Section behaviour
     ===================================================================== */
  function nightsUntil(dateStr) {
    var p = String(dateStr || '').split('-'); if (p.length < 3) return null;
    var target = new Date(+p[0], +p[1] - 1, +p[2]), now = new Date(), today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    return { n: Math.round((target - today) / 864e5), target: target, today: today };
  }
  function fillNights(root) {
    $$('[data-hw-nights]', root).forEach(function (el) {
      var r = nightsUntil(el.getAttribute('data-hw-nights')); if (!r) return;
      el.textContent = Math.max(0, r.n);
      var w = el.parentNode && el.parentNode.querySelector('[data-hw-nights-word]');
      if (w) w.textContent = r.n === 1 ? w.getAttribute('data-one') : w.getAttribute('data-other');
    });
  }

  /* 4. living jack-o'-lantern + wobbly headline */
  function initHero(root) {
    $$('.hw-wobble:not(.is-split)', root).forEach(function (w) {
      w.classList.add('is-split');
      var txt = w.textContent, esc = function (c) { return c.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); };
      w.innerHTML = '<span class="visually-hidden">' + esc(txt) + '</span>' + txt.split('').map(function (c) { return '<span aria-hidden="true">' + (c === ' ' ? '&nbsp;' : esc(c)) + '</span>'; }).join('');
    });
    $$('[data-hw-jack]', root).forEach(function (btn) {
      if (btn.hwInit) return; btn.hwInit = true;
      var svg = btn.querySelector('.hw-jack'), pl = btn.querySelector('.hw-pupil--l'), pr = btn.querySelector('.hw-pupil--r'), face = 0;
      window.addEventListener('pointermove', function (e) {
        var r = svg.getBoundingClientRect(); if (!r.width) return;
        [[pl, 140], [pr, 260]].forEach(function (a) {
          var ex = r.left + a[1] / 400 * r.width, ey = r.top + 186 / 380 * r.height;
          var ang = Math.atan2(e.clientY - ey, e.clientX - ex), d = Math.min(9, Math.hypot(e.clientX - ex, e.clientY - ey) / 30);
          a[0].setAttribute('transform', 'translate(' + (Math.cos(ang) * d) + ' ' + (Math.sin(ang) * d) + ')');
        });
      }, { passive: true });
      btn.addEventListener('click', function () {
        var faces = svg.querySelectorAll('.hw-face'); faces[face].classList.remove('is-on'); face = (face + 1) % faces.length; faces[face].classList.add('is-on');
        svg.classList.remove('is-flare'); void svg.getBoundingClientRect(); svg.classList.add('is-flare'); sfx.boo();
        var r = svg.getBoundingClientRect(); burst(r.left + r.width / 2, r.top + r.height * .4, 12, ['sweet', 'sweet', 'bat']);
      });
    });
  }

  /* 7. trick-or-treat tabs + bucket */
  function initTrickOrTreat(root) {
    $$('[data-hw-tot]', root).forEach(function (sec) {
      if (sec.hwInit) return; sec.hwInit = true;
      var tabs = $$('[role="tab"]', sec);
      function sel(t) { tabs.forEach(function (b) { var on = b === t; b.setAttribute('aria-selected', on); b.tabIndex = on ? 0 : -1; document.getElementById(b.getAttribute('aria-controls')).hidden = !on; }); }
      tabs.forEach(function (b, i) {
        b.addEventListener('click', function () { sel(b); sfx.pop(); });
        b.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length]; sel(n); n.focus(); } });
      });
      var bk = $('[data-hw-bucket-btn]', sec), dlg = $('.hw-dialog', sec), dataEl = $('script[data-hw-bucket]', sec);
      if (!bk || !dlg || !dataEl) return;
      var data = []; try { data = JSON.parse(dataEl.textContent); } catch (e) {}
      var current = null;
      function reach() {
        if (!data.length) return;
        bk.classList.remove('is-shaking'); void bk.offsetWidth; bk.classList.add('is-shaking'); sfx.boo();
        setTimeout(function () {
          current = pick(data);
          var v = $('.hw-dlg__verdict', dlg); v.textContent = current.treat ? sec.getAttribute('data-treat-word') : sec.getAttribute('data-trick-word'); v.classList.toggle('is-trick', !current.treat);
          $('h3', dlg).textContent = current.title; $('.hw-dlg__price', dlg).textContent = money(current.price);
          var im = $('.hw-dlg__img img', dlg); im.src = current.image || ''; im.alt = current.title; im.hidden = !current.image;
          var add = $('[data-hw-bucket-add]', dlg), view = $('[data-hw-bucket-view]', dlg);
          view.href = current.url;
          if (current.variant && current.available) { add.hidden = false; add.setAttribute('data-variant-id', current.variant); view.hidden = true; }
          else { add.hidden = true; view.hidden = false; }
          if (!dlg.open && dlg.showModal) dlg.showModal();
          var r = dlg.getBoundingClientRect(); burst(r.left + r.width / 2, r.top + 40, 14, ['sweet', 'sweet', current.treat ? 'pumpkin' : 'bat']);
        }, RM ? 0 : 600);
      }
      bk.addEventListener('click', reach);
      $('[data-hw-bucket-again]', dlg).addEventListener('click', reach);
      $('[data-hw-bucket-add]', dlg).addEventListener('click', function () { setTimeout(function () { dlg.close(); }, 50); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.closest('[data-hw-close]')) dlg.close(); });
    });
  }

  /* 9. carve-the-countdown */
  var PUMP = '<svg viewBox="0 0 40 40" aria-hidden="true"><path d="M20 7c-1-3 0-5 3-6l1 2c-2 1-2 2-2 4z" fill="#9be22d"/><g class="hw-pbody"><ellipse cx="13" cy="23" rx="10" ry="13" fill="#d9540a"/><ellipse cx="27" cy="23" rx="10" ry="13" fill="#d9540a"/><ellipse cx="20" cy="23" rx="11" ry="14" fill="#ff8a2a"/></g><path class="hw-fc" d="M12 19l5-1-2 5zM28 19l-5-1 2 5zM12 27c4 4 12 4 16 0-2 1-3 2-4 0-1 2-3 2-4 0-1 2-3 2-4 0-1 1-2 1-4 0z" fill="#ffe08a"/></svg>';
  function initCountdown(root) {
    $$('[data-hw-countdown]', root).forEach(function (sec) {
      if (sec.hwInit) return; sec.hwInit = true;
      var info = nightsUntil(sec.getAttribute('data-date')), patch = $('.hw-patch', sec), st = $('.hw-carve-status', sec);
      if (!info || !patch) return;
      var t = info.target, todayNum = (info.today.getFullYear() === t.getFullYear() && info.today.getMonth() === t.getMonth()) ? info.today.getDate() : (info.today > t ? 99 : 0);
      var toCarve = 0, carved = 0, html = '';
      for (var d = 1; d <= t.getDate(); d++) {
        var past = d <= todayNum; if (!past) toCarve++;
        html += '<button type="button" class="' + (past ? 'is-past is-carved' : '') + '"' + (past ? ' disabled' : '') + ' aria-label="' + (past ? S.pastNight : S.carveNight).replace('[d]', d) + '">' + PUMP + '<span class="hw-n">' + d + '</span></button>';
      }
      patch.innerHTML = html;
      if ((info.n <= 0 || !toCarve) && st) st.textContent = sec.getAttribute('data-done');
      patch.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b || b.disabled) return;
        var was = b.classList.toggle('is-carved'); carved += was ? 1 : -1;
        if (st) st.textContent = carved ? S.carved.replace('[n]', carved).replace('[t]', toCarve) + (carved === toCarve ? ' ' + S.patchLit : '') : '';
        var r = b.getBoundingClientRect(); if (was) { sfx.pop(); burst(r.left + r.width / 2, r.top, 4, ['sweet']); }
        if (was && carved === toCarve) { sfx.chime(); swarm(22); toast(S.allCarved); }
      });
      if (sec.getAttribute('data-bats') === 'true' && 'IntersectionObserver' in window) {
        var done = false; new IntersectionObserver(function (es, o) { if (es[0].isIntersecting && !done) { done = true; o.disconnect(); setTimeout(function () { swarm(10); }, 300); } }, { threshold: .45 }).observe(sec);
      }
    });
  }

  /* build-a-shelf bundle */
  function initBundle(root) {
    $$('[data-hw-bundle]', root).forEach(function (sec) {
      if (sec.hwInit) return; sec.hwInit = true;
      var list = $('.hw-tally ul', sec), tot = $('.hw-tally__tot b', sec), shelf = $('.hw-shelf', sec), btn = $('[data-hw-bundle-add]', sec);
      function checked() { return $$('.hw-pick input:checked', sec); }
      function tally() {
        var on = checked(), sum = 0;
        list.innerHTML = on.length ? on.map(function (i) { sum += +i.getAttribute('data-price'); return '<li><span></span><span>' + money(+i.getAttribute('data-price')) + '</span></li>'; }).join('') : '<li class="hw-empty">' + sec.getAttribute('data-empty') + '</li>';
        on.forEach(function (i, n) { list.children[n].firstChild.textContent = i.getAttribute('data-title'); });
        tot.textContent = money(sum);
        var have = $$('span', shelf).map(function (s) { return s.getAttribute('data-v'); }), ids = on.map(function (i) { return i.value; });
        $$('span', shelf).forEach(function (s) { if (ids.indexOf(s.getAttribute('data-v')) === -1) s.remove(); });
        on.forEach(function (i) { if (have.indexOf(i.value) === -1) { var s = document.createElement('span'); s.setAttribute('data-v', i.value); var im = i.getAttribute('data-img'); if (im) s.style.backgroundImage = 'url("' + im + '")'; shelf.appendChild(s); } });
      }
      sec.addEventListener('change', function () { tally(); sfx.pop(); });
      tally();
      btn.addEventListener('click', function () {
        var on = checked(); if (!on.length) { toast(sec.getAttribute('data-empty')); return; }
        btn.disabled = true;
        addToCart(on.map(function (i) { return { id: +i.value, quantity: 1 }; }), btn).then(function () { btn.disabled = false; });
      });
    });
  }

  function initSections(root) { fillNights(root); initHero(root); initTrickOrTreat(root); initCountdown(root); initBundle(root); booCards(root); }

  function boot() {
    initSections(document);
    initRain(); initTrail(); initSpider(); initGhosts(); initSound();
    var main = document.getElementById('MainContent');
    if (main && 'MutationObserver' in window && CFG.boo) {
      var to; new MutationObserver(function () { clearTimeout(to); to = setTimeout(function () { booCards(main); }, 150); }).observe(main, { childList: true, subtree: true });
    }
  }
  document.addEventListener('shopify:section:load', function (e) { initSections(e.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
